import { Component, OnInit, ViewChild ,Inject} from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialog, MAT_DIALOG_DATA, MatDatepickerInputEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/service/api.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as _moment from 'moment';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { numValidation } from 'src/app/service/customValidation';
import { Select2OptionData } from 'ng-select2';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment.prod';
import { DataPassingService } from 'src/app/service/data-passing.service';
import { ExcelService } from 'src/app/service/excel.service';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export interface StandardElement {
  name: string;
  dueAmount: string;
}



@Component({
  selector: 'app-student-list',
  templateUrl: './student-list.component.html',
  styleUrls: ['./student-list.component.css'],
  providers:[
    {provide:DateAdapter,useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class StudentListComponent implements OnInit {

  displayedColumns: string[] = ['name','dueDate','loanAmount','paidAmount','remainAmount','action'];
  dataSource:MatTableDataSource<any>=new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataTable: any;
  showLoading=false;
  tblLoading=false;
  itemTotal=0;
  studList=true;
  isForm=false;
  isReceipt=false;
  isSubmitted=false;
  isSuccess=false;
  isError=false;
  message='';
  inputFormGroup:FormGroup;
  selectFormGroup:FormGroup;
  isGreater=false;
  isDisabled=false;
  searching = false;
  searchFailed = false;
  returnData:any=[];
  srNo=0;
  startDate='';
  endDate='';
  name='';
  paymentModeList:Array<Select2OptionData>;
  pendingBalance=0;
  maxDate=new Date();
  maxValid=false
  constructor(private excelService:ExcelService,private formBuilder:FormBuilder,private api:ApiService,private route:ActivatedRoute,private datePipe:DatePipe,private dataPass:DataPassingService,private router:Router,public dialog: MatDialog) {
    this.inputFormGroup=this.formBuilder.group({
      id:[''],
      name:[''],
      dueDate:['',Validators.required],
      scholarship:['',[Validators.required,numValidation()]],
      paymentMode:['',Validators.required],
      reference:[''],
      bank:[''],
      loan_id:[''],
      remaining:['',[Validators.required,numValidation()]],
      installment:['',[Validators.required,numValidation()]],
      withdraw:['',[Validators.required,numValidation()]]
    });
    this.selectFormGroup=this.formBuilder.group({
      startDate:['',Validators.required],
      endDate:['',Validators.required]
    });
   }

  ngOnInit() {
    this.route.data.subscribe(data=>{
      this.itemTotal=parseInt(data.stud[0].total);
      this.dataSource.data=data.stud[0].data;
      this.pendingBalance=data.stud[2].totalPendingAmount;
    },(error)=>{

    });
   
    

    this.paymentModeList=[];
    this.route.data.subscribe(data=>{
      data.stud[1].data.forEach(element => {
        let aData={id:element.id,text:element.name};
        this.paymentModeList.push(aData);
      });
    },(error)=>{});

  }

  exportAsXLSX():void {
    this.api.get("admission?&export=excel").subscribe(data=>{
      this.itemTotal=parseInt(data.total);
      data.data.push({"Mobile":"Totals","Scholarship":data.totals.totalScholarship,"Withdraw":data.totals.totalPaid,"Pending":data.totals.totalPending});
      this.excelService.exportAsExcelFile(data.data, 'studentList');
    },(error)=>{

    });
    
 }

 reset()
  {
    window.location.reload();
  }

 counter(i)
 {
   let num=i+1;
   return this.srNo+num;
 }

 searchname(e)
 {
   let url='';
   if(e.target.value.length>1)
   {
    url="admission?&orderBy=dueDate_desc&start=0&length=10&search="+e.target.value;
   }
   else if(e.target.value.length==0)
   {
     url="admission?&orderBy=dueDate_desc&start=0&length=10&";
   }

   this.api.get(url).subscribe(data=>{
    this.itemTotal=parseInt(data.total);
    this.dataSource.data=data.data;
  },(error)=>{

  });
    
 }

 onEdit(id)
  {
    this.dataPass.passDataService({id:id});
    this.router.navigateByUrl("/admin/admission");
  }

  fetch(form)
  {
    this.isSubmitted=true;
    if(this.selectFormGroup.invalid)
    {
      return false;
    }
    else
    {
      this.startDate=(form.value.startDate!="")?this.datePipe.transform(form.value.startDate,"dd/MM/yyyy"):'';
    this.endDate=(form.value.endDate!="")?this.datePipe.transform(form.value.endDate,"dd/MM/yyyy"):'';
    this.refreshTable(0,10);
    }
    
    
  }

  tblItmPageChange(event)
  {
    let start=(event.pageIndex>0)?(event.pageSize*event.pageIndex):event.pageIndex;
    this.srNo=start;
    this.refreshTable(start,event.pageSize);
  }

/*  refreshTable(start,pageSize)
  {
    this.api.get("admission?&orderBy=dueDate_desc&start="+start+"&length="+pageSize).subscribe(data=>{
      this.itemTotal=parseInt(data.total);
      this.dataSource.data=data.data;
    },(error)=>{

    });
  }*/

  refreshTable(start,pageSize)
  {
    if(this.startDate!="" && this.endDate!="")
    {
      this.api.get("admission?orderBy=dueDate_desc&start="+start+"&length="+pageSize+"&startDate="+this.startDate+"&endDate="+this.endDate).subscribe(data=>{
        this.itemTotal=parseInt(data.total);
        this.dataSource.data=data.data;
      },(error)=>{

      });
    }
    else
    {
      this.api.get("admission?orderBy=dueDate_desc&start="+start+"&length="+pageSize).subscribe(data=>{
        this.itemTotal=parseInt(data.total);
        this.dataSource.data=data.data;
      },(error)=>{

      });
    }
    
    this.api.get('totalPendingAmount').subscribe(data=>{
      this.pendingBalance=data.totalPendingAmount;
    });
    
  }

  onPayment(id,name,amount,loan_id,remaining,duration)
  {
    this.studList=false;
    this.isForm=true;
    let years=Math.floor(duration/12);
    let iamount=Math.floor(amount/years);
    let installment=(remaining<=iamount)?remaining:iamount;
    this.inputFormGroup.patchValue({id:id,name:name,scholarship:amount,loan_id:loan_id,remaining:remaining,installment:installment});
    
  }

  receiptNo(no)
  {
    let num=no.toString();
    if(num.length<2)
    {
      return '00'+num;
    }
    else if(num.length<3)
    {
      return '0'+num;
    }
    else
    {
      return num;
    }

  }

  changePage(event)
  {
    event.preventDefault();
   // this.isForm=!this.isForm;
    this.isReceipt=false;
    this.studList=true;
  }

  calculateInstallment(i,no,paid,dt)
  {
    let ino=(parseInt(no)==0)?1:parseInt(no)+1;
    let iamount=parseInt(i)*ino-paid;
    let ndt=new Date(dt);
    let cdt=new Date();
    let ramt=(cdt>=ndt)?iamount:0;
    return ramt;
  }
 

  print()
  {
    window.print();
  }

  saveForm(form)
  {
    this.returnData=[];
    this.isError=false;
    this.isSuccess=false;
    this.isDisabled=true;
    this.isSubmitted=true;
    if(this.inputFormGroup.invalid)
    {
      this.isDisabled=false;
      return false;
    }
    else
    {
      form.value.dueDate=(form.value.dueDate!="")?this.datePipe.transform(form.value.dueDate,"dd/MM/yyyy"):'';
      this.api.post(form.value,'withdraw').subscribe(data=>{
        if(data.status)
        {
          
          this.studList=true;
          this.isForm=!this.isForm;
          this.refreshTable(0,10);
         
        }
        else
        {
          this.message=data.message;
          alert(this.message);
          this.studList=true;
          this.isForm=!this.isForm;
          this.refreshTable(0,10);
        }

        this.isSubmitted=false;
        this.isDisabled=false;
        this.inputFormGroup.reset();
        document.querySelector<HTMLInputElement>("#name").value='';
      },(error)=>{});

    }
  }

  checkValue()
    {
      
      let amountToPay=this.inputFormGroup.controls.installment.value;
      let paidAmount=this.inputFormGroup.controls.withdraw.value;
     
      if(parseInt(paidAmount)>parseInt(amountToPay))
      {
        this.isGreater=true;
        this.isDisabled=true;
      }
      else
      {
       this.isGreater=false;
       this.isDisabled=false;
      }
  
    }

  dateTranform()
  {
    let dt=new Date();
    return this.datePipe.transform(dt,"dd/MM/yyyy");
  }

  dateValTranform(dt)
  {
    return this.datePipe.transform(dt,"dd/MM/yyyy");
  }

  onView(e,id)
  {
    e.preventDefault();
    const dialogRef = this.dialog.open(DialogDataExampleDialog,{
      data: {
        id:id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      
    });
  }

  convertNumberToWords(amount) {
    let words = new Array();
    words[0] = '';
    words[1] = 'One';
    words[2] = 'Two';
    words[3] = 'Three';
    words[4] = 'Four';
    words[5] = 'Five';
    words[6] = 'Six';
    words[7] = 'Seven';
    words[8] = 'Eight';
    words[9] = 'Nine';
    words[10] = 'Ten';
    words[11] = 'Eleven';
    words[12] = 'Twelve';
    words[13] = 'Thirteen';
    words[14] = 'Fourteen';
    words[15] = 'Fifteen';
    words[16] = 'Sixteen';
    words[17] = 'Seventeen';
    words[18] = 'Eighteen';
    words[19] = 'Nineteen';
    words[20] = 'Twenty';
    words[30] = 'Thirty';
    words[40] = 'Forty';
    words[50] = 'Fifty';
    words[60] = 'Sixty';
    words[70] = 'Seventy';
    words[80] = 'Eighty';
    words[90] = 'Ninety';
    amount = amount.toString();
    let atemp = amount.split(".");
    let number = atemp[0].split(",").join("");
    let n_length = number.length;
    let words_string = "";
    if (n_length <= 9) {
        let n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
        let received_n_array = new Array();
        for (let i = 0; i < n_length; i++) {
            received_n_array[i] = number.substr(i, 1);
        }
        for (let i = 9 - n_length, j = 0; i < 9; i++, j++) {
            n_array[i] = received_n_array[j];
        }
        for (let i = 0, j = 1; i < 9; i++, j++) {
            if (i == 0 || i == 2 || i == 4 || i == 7) {
                if (n_array[i] == 1) {
                    n_array[j] = 10 + n_array[j];
                    n_array[i] = 0;
                }
            }
        }
        let value = 0;
        for (let i = 0; i < 9; i++) {
            if (i == 0 || i == 2 || i == 4 || i == 7) {
                value = n_array[i] * 10;
            } else {
                value = n_array[i];
            }
            if (value != 0) {
                words_string += words[value] + " ";
            }
            if ((i == 1 && value != 0) || (i == 0 && value != 0 && n_array[i + 1] == 0)) {
                words_string += "Crores ";
            }
            if ((i == 3 && value != 0) || (i == 2 && value != 0 && n_array[i + 1] == 0)) {
                words_string += "Lakhs ";
            }
            if ((i == 5 && value != 0) || (i == 4 && value != 0 && n_array[i + 1] == 0)) {
                words_string += "Thousand ";
            }
            if (i == 6 && value != 0 && (n_array[i + 1] != 0 && n_array[i + 2] != 0)) {
                words_string += "Hundred and ";
            } else if (i == 6 && value != 0) {
                words_string += "Hundred ";
            }
        }
        words_string = words_string.split("  ").join(" ");
    }
    return words_string;
  }

  dateEvent(type: string, event: MatDatepickerInputEvent<any>) {
    this.isDisabled=false;
    this.maxValid=false;
    let dt=event.value._d;
    let nwDt=new Date();
    if(dt>=nwDt)
    {
      this.isDisabled=true;
      this.maxValid=true;
     
      
    }
    
    
  }


}

@Component({
  selector: 'dialog-data-example-dialog',
  templateUrl:'./view-student.html',
  styleUrls: ['./student-list.component.css'],
})
export class DialogDataExampleDialog {
  public providerAmount=0;
  public totalDonation=0;
  showLoading=true;
  public paid=0;
  
  constructor(private dataPass:DataPassingService,private api:ApiService,@Inject(MAT_DIALOG_DATA) public data: any,private datePipe:DatePipe) {
    this.data.donarPayment=[];
    
    this.api.get('studentDetails?id='+data.id).subscribe(data=>{
     this.data=data.student;
     this.data.studentPayments=data.studentPayments;
     this.data.donarPayments=data.donarPayments;
     this.data.refunds=data.refunds;
     
     if(data.donarPayments!="")
     {
      data.donarPayments.forEach(el => {
        if(el.amount)
        {
          this.totalDonation+=parseInt(el.amount);
        }
         
      });
     }
     
     this.providerAmount=data.donar.provider_amount;
         this.paid=data.donar.paid_amount;
         this.showLoading=false;
        },(error)=>{

        });
       
        
  }

  trustPaid(amount)
  {
    if(amount<=this.totalDonation)
    {
      return 0;
    }
    else if(amount>this.totalDonation)
    {
      return amount-this.totalDonation;
    }
    else
    {
      return amount;
    }
  }

  DonarPaid(amount)
  {
    if(amount<=this.totalDonation)
    {
      return amount;
    }
    else if(amount>this.totalDonation)
    {
      return this.totalDonation;
    }
    else
    {
      return 0;
    }
    
  }

  trust(amount)
  {
    if(amount==undefined)
    {
      return 0;
    }
    else
    {
      return amount;
    }
    
  }

 

  donarPayment(amount,paid,i)
  {
    
    if(paid==undefined)
    {
      paid=0;
      return 0
    }
    else
    {
      if(this.data.donarPayment[i]==undefined)
      {
          return 0;
      }
      else
      {
        if(parseInt(this.data.donarPayment[i].amount)>parseInt(amount))
        {
          return parseInt(amount);
        }
        else{
          return parseInt(amount)-parseInt(this.data.donarPayment[i].amount);
        }
        
      }
      
    }

  }

  
 
  dateValTranform(dt)
  {
    return this.datePipe.transform(dt,"dd/MM/yyyy");
  }

  
  
}
